module.exports = __webpack_public_path__ + "static/008476-5866dae010ef62780d643f232cd55397.jpg";